//packages blocks
import { Box, CircularProgress, Typography } from "@material-ui/core";
import React, { useEffect } from "react";
//common blocks
import "./paymentLayer.css";
//styles, utils, assets and api blocks
import { BLACK } from "../../../theme";
import logo from "../../../assets/images/logo-v1.png";

const PaymentLayerComponent = () => {

  useEffect(() => {
    document.title = "Login - Paynest";
  }, []);

  return (
    <div className="login-page">
      <div className="loginForm">
        <div className="payNest_logo_login" >
          <img src={logo} />
        </div>

        <div className="login-form-group">
          <Box style={{
            height: "200px",
            width: "100%",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            flexDirection: "column",
          }}>
            <CircularProgress size={30} style={{ color: "black" }} />
            <Typography variant="h6" style={{ margin: 20, fontSize: 12, textAlign: 'center' }}>
              Please wait while your transaction is in progress.
            </Typography>
          </Box>
        </div>
      </div>
    </div>
  );
};

export default PaymentLayerComponent;
